<div class="add-note-templates-dialog">
  <div>
    <span>Note</span>
  </div>
  <div class="import-dialog-content">
      <owc-input appearance="outline" [formControl]="addNoteFC" ></owc-input>
  </div>
  <div class="import-dialog-actions">
    <owc-button
       class="cancel-button"
       (click)="cancelClicked()">
      Cancel
    </owc-button>
    <owc-button color="primary" (click)="saveNote()">
      Accept
    </owc-button>
  </div>
</div>
